import { render, staticRenderFns } from "./ShipmentStatuses.vue?vue&type=template&id=20e99460&"
import script from "./ShipmentStatuses.vue?vue&type=script&lang=js&"
export * from "./ShipmentStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports